<template>
  <v-chip-group
    active-class="primary white--text"
    column
    class="ma-0 pa-2 red--text"
    :multiple="multiple"
    v-model="model"
  >
    <v-chip
      :outlined="
        (multiple && (!model || !model.includes(index))) ||
        (!multiple && model != index)
      "
      class="vetalfa-chip-component-size text-left px-3"
      color="primary"
      filter
      v-for="(item, index) in items"
      :key="`chip-group-${item}`"
    >
      {{ item }}
    </v-chip>
  </v-chip-group>
</template>

<script>
export default {
  name: "ChipGroup",
  props: {
    items: { default: [], required: true },
    multiple: { default: false, required: false, type: Boolean },
    defaultValue: { default: undefined, required: false },
    clearTrigger: { default: null, required: true },
  },
  data() {
    return {
      model: null,
    };
  },
  methods: {
    clear() {
      this.model = this.defaultValue;
    },
  },
  watch: {
    model(val) {
      this.$emit("selectChip", val);
    },
    clearTrigger() {
      this.clear();
    },
  },
  created() {
    this.model = this.defaultValue;
  },
};
</script>